import { IconFont, Menu, pointer, Popover } from '@byecode/ui'
import React, { useState } from 'react'
import styled from 'styled-components'

const SCxIconWrapper = styled.div`
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    background-color: var(--color-gray-100);
    ${pointer}
    &:hover {
        background-color: var(--color-gray-200);
    }
`

interface DeviceIconPickerProps {
    value: string
    onChange: (val: string) => void
}

const iconList = ['DeviceDesktop', 'DeviceTablet', 'DeviceMobile', 'ScreenM', 'ScreenS', 'ScreenL']

export const DeviceIconPicker: React.FC<DeviceIconPickerProps> = ({ value, onChange }) => {
    const [opened, setOpened] = useState(false)

    return (
        <Menu opened={opened} position="bottom-start" onChange={setOpened} width={109}>
            <Menu.Target>
                <SCxIconWrapper>
                    <IconFont size={20} type={value} />
                </SCxIconWrapper>
            </Menu.Target>
            <Menu.Dropdown>
                {iconList.map(icon => (
                    <Menu.Item
                        key={icon}
                        onClick={() => {
                            setOpened(false)
                            onChange(icon)
                        }}
                        rightSection={icon === value && <IconFont type="Tick" fill="var(--color-main)" />}
                    >
                        <IconFont size={20} type={icon} />
                    </Menu.Item>
                ))}
            </Menu.Dropdown>
        </Menu>
    )
}
